// extracted by mini-css-extract-plugin
export default {"container":"PrivateLayout_container__OG4Wy"};